import { IRootState } from '../../../store'
import {
  INotificationConfig,
  IAppSettingsEntry,
  DEFAULT_NOTIFICATION_CONFIG,
} from '../../configurations/store/configurations.types'
import { INotificationCenterState } from '../store/notificationCenter.types'
import { NotificationCenterConstants } from '../store/notificationCenter.constants'

export const getNotificationCenterSelector = (state: IRootState): INotificationCenterState => state.notificationCenter

export const hasNewNotificationsSelector = (state: IRootState): boolean =>
  state.notificationCenter.polledNotificationIds.some(
    (id) => !state.notificationCenter.viewedNotificationIds.includes(id)
  )

export const getNotificationConfigSelector = (state: IRootState): INotificationConfig => {
  const entries: IAppSettingsEntry[] = state.configurations?.appSettingsEntries ?? []
  const get = (key: string) => entries.find((e) => e.key === key)?.value
  return {
    retryCount: get(NotificationCenterConstants.NOTIFICATION_RETRY_COUNT) ?? DEFAULT_NOTIFICATION_CONFIG.retryCount,
    minIntervalMinutes:
      get(NotificationCenterConstants.NOTIFICATION_POLLING_INTERVAL_IN_MINS) ??
      DEFAULT_NOTIFICATION_CONFIG.minIntervalMinutes,
  }
}
